<div class="setting-card" (click)="onCardClick()">
  <div class="setting-card__container">
    @if (!hideIcon()) {
      <div class="setting-card__icon-container">
        @if (isIconFile()) {
          <div
            class="setting-card__icon setting-card__icon--img"
            [ngStyle]="{
              '-webkit-mask-image': 'url(' + icon() + ')',
              'mask-image': 'url(' + icon() + ')'
            }"></div>
        } @else {
          <div
            class="setting-card__icon"
            [innerHTML]="getSafeIcon()"></div>
        }
      </div>
    }

    <div class="setting-card__content">
      <div class="setting-card__header">
        <h3 class="setting-card__title">{{ title() }}</h3>
        <div class="setting-card__arrow">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
      <p class="setting-card__description">{{ description() }}</p>
    </div>
  </div>
</div>
